import { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import swal from 'sweetalert';
// component
import Iconify from '../../../components/Iconify';
import { disableTimeSlot } from '../../../common/api-service';

// ----------------------------------------------------------------------
const TimeSlotMoreMenu = ({ data }) => {
  const navigate = useNavigate();

  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState(data);
  const handleDelete = () => {
    const payload = {
      _id: id,
      status: 'disabled',
    };
    return disableTimeSlot(payload).then((res) => {
      if (res.data.status === true) {
        swal({
          title: res.data.message,
          icon: 'success',
          timer: 2000,
          button: false,
        });
      } else {
        swal({
          title: res.data.message,
          icon: 'danger',
          timer: 2000,
          button: false,
        });
      }
    });
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} onClick={handleDelete} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default TimeSlotMoreMenu;
